import { api } from "./api";
import { confirmPayment } from "./subscription";

export const AuthService = {
  // LOCATAIRE
  async registerTenant(payload) {
    // payload: {lastName, firstName, idCard, phone, email, whatsapp, username, password}
    const { data } = await api.post("/auth/register/tenant", payload);
    return data;
  },

  // VENDEUR
  async registerVendor(payload) {
    const { data } = await api.post("/auth/register/vendor", payload);
    return data;
  },

  // PROPRIETAIRE
  async registerOwner(payload) {
    const { data } = await api.post("/auth/register/owner", payload);
    return data;
  },

  // MANAGER
  async registerManager(payload) {
    try {
      const { data } = await api.post("/auth/register/manager", payload);
      console.log("AuthService.registerManager", data);
      console.log("AuthService.registerManager payload", payload);
      return data;
    } catch (err) {
      console.error("Erreur registerManager:", err);
      throw err;
    }
  },

  // CONNEXION
  async login({ identifier, password }) {
    // identifier = email ou phone
    const { data } = await api.post("/auth/login", { identifier, password });
    if (data?.token) localStorage.setItem("auth_token", data.token);
    return data;
  },

  async logout() {
    try {
      await api.post("/auth/logout");
    } finally {
      localStorage.removeItem("auth_token");
    }
  },

  async me() {
    const { data } = await api.get("/auth/me");
    console.log("AuthService.me", data);
    return data;
  },

  async updateProfile(payload) {
    const { data } = await api.put("/auth/profile", payload);
    return data;
  },

  async changePassword(payload) {
    const { data } = await api.post("/auth/change-password", payload);
    return data;
  },

  // 🆕 HISTORIQUE DES ACTIONS
  async getActionHistory(params = {}) {
    try {
      const { data } = await api.get("/auth/action-history", { params });
      console.log("AuthService.getActionHistory", data);
      return data;
    } catch (err) {
      console.error("Erreur getActionHistory:", err);
      throw err;
    }
  },

  // PAIEMENTS
  async listPayments() {
    const { data } = await api.get("/auth/payments");
    console.log("AuthService.listPayments", data);
    return data;
  },

  async confirmPayment(transaction_id) {
    try {
      console.log("AuthService.confirmPayment", transaction_id);
      const data = await confirmPayment(transaction_id);
      console.log("AuthService.confirmPayment data", data);
      return data;
    } catch (err) {
      console.error("Erreur confirmPayment:", err);
      throw err;
    }
  },

  // GESTION DES RÔLES
  async addRole(role) {
    // role = 'owner' | 'vendor' | 'tenant' | 'manager'
    const { data } = await api.post("/auth/role/add", { role });
    return data;
  },

  async switchRole(role) {
    // Changer le rôle actif
    const { data } = await api.post("/auth/role/switch", { role });
    return data;
  },

  async getRolesStatuses() {
    // Récupérer les statuts de tous les rôles
    const { data } = await api.get("/me/subscription");
    return data;
  },

  // MOT DE PASSE OUBLIÉ
  async forgotPassword({ identifier, id_card }) {
    const { data } = await api.post("/auth/forgot-password", { identifier, id_card });
    return data;
  },

  async resetPassword({ user_id, reset_token, new_password, new_password_confirmation }) {
    const { data } = await api.post("/auth/reset-password", { 
      user_id, 
      reset_token, 
      new_password, 
      new_password_confirmation 
    });
    return data;
  },

  async verifyResetToken({ user_id, reset_token }) {
    const { data } = await api.post("/auth/verify-reset-token", { user_id, reset_token });
    return data;
  },

  // CONSENTEMENTS
  async getConsentStatus() {
    // GET /api/consents/status  -> { accepted: boolean, accepted_at: ... }
    const { data } = await api.get("/consents/status");
    return data;
  },

  async acceptConsent() {
    // POST /api/consents/accept {accepted:true}
    try {
      const { data } = await api.post("/consents/accept", { accepted: true });
      return data;
    } catch (err) {
      console.error("Erreur acceptConsent:", err);
      throw err;
    }
  },

  // AVATAR
  async avatarUploadBase64(avatar_base64) {
    try {
      const { data } = await api.post("/auth/avatar/upload", { avatar_base64 });
      return data;
    } catch (err) {
      console.error("Erreur avatarUploadBase64:", err);
      throw err;
    }
  },

  // services/auth.js
async deleteAccount() {
  const { data } = await api.delete("/auth/delete-my-account");
  return data;
}

};
